import useCurrentUserHasRole from "./useCurrentUserHasRole.js";
import {paymentMethods} from "../utils.js";

const usePaymentMethods = () => {
    const paymentPosTerminal = useCurrentUserHasRole('ROLE_PAYMENT_POS_TERMINAL');
    const paymentBankAccountBroker = useCurrentUserHasRole('ROLE_PAYMENT_BANK_ACCOUNT_BROKER');
    const paymentBankAccountInsuranceCompany = useCurrentUserHasRole('ROLE_PAYMENT_BANK_ACCOUNT_INSURANCE_COMPANY');
    const paymentPending = useCurrentUserHasRole('ROLE_PAYMENT_PENDING_PAYMENT');

    const getPaymentMethod = paymentMethod => ({
        value: paymentMethod,
        label: paymentMethods[paymentMethod],
    });

    const paymentMethodOptions = [
        getPaymentMethod('CASH'),
        ...(paymentPosTerminal ? [getPaymentMethod('POS_TERMINAL')] : []),
        ...(paymentBankAccountBroker ? [getPaymentMethod('BANK_ACCOUNT_BROKER')] : []),
        ...(paymentPending ? [getPaymentMethod('PENDING_PAYMENT')] : []),
        ...(paymentBankAccountInsuranceCompany ? [getPaymentMethod('BANK_ACCOUNT_INSURANCE_COMPANY')] : [])];

    const paymentMethodIcons = {
        CASH: {
            icon: 'money-bill-1',
            iconWidth: 43,
        },
        CASH_CURRENCY: {
            icon: 'euro-sign',
            iconWidth: 43,
        },
        POS_TERMINAL: {
            icon: 'credit-card',
            iconWidth: 43,
        },
        BANK_ACCOUNT_BROKER: {
            icon: 'building-columns',
            iconWidth: 41,
        },
        BANK_ACCOUNT_INSURANCE_COMPANY: {
            icon: 'building-columns',
            iconWidth: 41,
        },
        PENDING_PAYMENT: {
            icon: 'clock-rotate-left',
            iconWidth: 41,
        },
    };

    const hasNonCashPaymentMethods = paymentPosTerminal || paymentBankAccountBroker || paymentBankAccountInsuranceCompany;

    return {
        paymentMethodOptions,
        paymentMethodIcons,
        hasNonCashPaymentMethods,
    };
};

export default usePaymentMethods;
